// extracted by mini-css-extract-plugin
export default {"dots":"AssistantMessageEmpty_dots__KTxuP","pulse-dots":"AssistantMessageEmpty_pulse-dots__5QY+j"};